<div class="when-wrapper">
  <div class="left" style="height: 22px">
    <svg-icon style="height: 22px" [svgStyle]="{'width.px': 20, 'height.px': 22}" src="/assets/icons/calendar_2.svg"></svg-icon>
  </div>
  <div class="right" #whenInput>
    <div i18n-placeholder="@@checkInPlaceholder" [attr.placeholder]="!value ? 'Check in' : null">
      {{ !value ? checkInPlaceholder : (value[0] | date : 'EEE, MMM d') }}
    </div>
    <div style="height: 18px; margin-top: 2px">
      <svg-icon style="height: 18px" [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/arrow.svg"></svg-icon>
    </div>
    <div i18n-placeholder="@@checkOutPlaceholder" [attr.placeholder]="!value ? 'Check out' : null">
      {{ !value ? checkOutPlaceholder : (value[1] | date : 'EEE, MMM d') }}
    </div>
  </div>
  <ng-container *ngIf="focused | async">
    <div class="calendar-wrapper" (outsideClick)="setFocus(false)" [exclude]="[whenInput]">
      <div class="calendar-content">
        <div class="card calendar" [class.vertical]="vertical">
          <div class="top">
            <div class="calendar-from">
              <div class="control" *ngIf="!vertical">
                <button class="btn month-control-btn" (click)="previousMonth()" [disabled]="monthOffset < 1">
                  <svg-icon src="/assets/icons/left.svg"></svg-icon>
                </button>
              </div>
              <div class="month">
                <div class="title">
                  {{ fromMonth | month }} {{ fromYear }}
                </div>
                <div class="days">
                  <div>
                    <span>S</span>
                  </div>
                  <div>
                    <span>M</span>
                  </div>
                  <div>
                    <span>T</span>
                  </div>
                  <div>
                    <span>W</span>
                  </div>
                  <div>
                    <span>T</span>
                  </div>
                  <div>
                    <span>F</span>
                  </div>
                  <div>
                    <span>S</span>
                  </div>
                </div>
                <div class="dates">
                  <ng-container *ngFor="let i of days;">
                    <ng-container *ngIf="(i > fromStartDay!) && ((i - fromStartDay!) <= fromDays!); else empty">
                      <app-day
                        [attr.data-i]="i"
                        [noAvailability]="noAvailability"
                        [attr.data-date]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                        (dayMouseenter)="highlight(i)"
                        (dayMouseleave)="unhighlight()"
                        (dayClick)="clicked(i, i - fromStartDay, true)"
                        [i]="i"
                        [dateValue]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                        [anchorStart]="anchorStart"
                        [(anchorStartDate)]="anchorStartDate"
                        [anchorEnd]="anchorEnd"
                        [(anchorEndDate)]="anchorEndDate"
                        [(selecting)]="selecting"
                        [firstDayOfMonth]="fromStartDay"
                        [daysInMonth]="fromDays"
                        [toStartDay]="toStartDay"
                        [fromStartDay]="fromStartDay"
                        [monthOffset]="monthOffset"
                        [absoluteAnchorStart]="absoluteAnchorStart"
                        [absoluteAnchorEnd]="absoluteAnchorEnd"
                        [focus]="focus"
                        [month]="'from'"
                        [fromMonth]="fromMonth"
                        [toMonth]="toMonth"
                        [unavailableDates]="unavailableDates"
                        >
                        <span>{{ i - fromStartDay! }}</span>
                      </app-day>
                    </ng-container>
                    <ng-template #empty>
                      <div class="date date-empty">
                        <span></span>
                      </div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="calendar-to">
              <div class="control" *ngIf="!vertical">
                <button class="btn month-control-btn" (click)="nextMonth()">
                  <svg-icon src="/assets/icons/right.svg"></svg-icon>
                </button>
              </div>
              <div class="month">
                <div class="title">
                  {{ toMonth | month }} {{ toYear }}
                </div>
                <div class="days">
                  <div>
                    <span>S</span>
                  </div>
                  <div>
                    <span>M</span>
                  </div>
                  <div>
                    <span>T</span>
                  </div>
                  <div>
                    <span>W</span>
                  </div>
                  <div>
                    <span>T</span>
                  </div>
                  <div>
                    <span>F</span>
                  </div>
                  <div>
                    <span>S</span>
                  </div>
                </div>
                <div class="dates">
                  <ng-container *ngFor="let i of days;">
                    <ng-container *ngIf="i - 1 >= toStartDay! && (i - toStartDay) <= toDays!; else empty">
                      <app-day
                        [attr.data-i]="i + 40"
                        [noAvailability]="noAvailability"
                        [attr.data-date]="i | dayToDate : toMonth : toStartDay : toYear"
                        (dayMouseenter)="highlight(i + 40)"
                        (dayMouseleave)="unhighlight()"
                        (dayClick)="clicked(i + 40, i - toStartDay)"
                        [i]="i + 40"
                        [dateValue]="i | dayToDate : toMonth : toStartDay : toYear"
                        [anchorStart]="anchorStart"
                        [(anchorStartDate)]="anchorStartDate"
                        [anchorEnd]="anchorEnd"
                        [(anchorEndDate)]="anchorEndDate"
                        [(selecting)]="selecting"
                        [firstDayOfMonth]="toStartDay"
                        [daysInMonth]="toDays"
                        [toStartDay]="toStartDay"
                        [fromStartDay]="fromStartDay"
                        [monthOffset]="monthOffset"
                        [absoluteAnchorStart]="absoluteAnchorStart"
                        [absoluteAnchorEnd]="absoluteAnchorEnd"
                        [focus]="focus"
                        [month]="'to'"
                        [fromMonth]="fromMonth"
                        [toMonth]="toMonth"
                        [unavailableDates]="unavailableDates"
                        >
                        <span>{{ i - toStartDay }}</span>
                      </app-day>
                    </ng-container>
                    <ng-template #empty>
                      <div class="date date-empty">
                        <span></span>
                      </div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="buttons">
              <button class="btn btn-frame" (click)="reset()">
                Clear
              </button>
              <button class="btn btn-theme" (click)="doUpdate()" [disabled]="!startDate || !endDate" (click)="doUpdate();close()">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>



<!-- <div class="left" style="height: 22px">
  <svg-icon style="height: 22px" [svgStyle]="{'width.px': 20, 'height.px': 22}" src="/assets/icons/calendar_2.svg"></svg-icon>
</div>
<div class="right">
  <div>Check in</div>
  <svg-icon style="height: 18px" [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/arrow.svg"></svg-icon>
  <div>Check out</div>
</div> -->
